import { render, staticRenderFns } from "./FactSheetPage.vue?vue&type=template&id=12b0d406&scoped=true&"
import script from "./FactSheetPage.vue?vue&type=script&lang=js&"
export * from "./FactSheetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0d406",
  null
  
)

export default component.exports